import { CasStackRow } from 'src/compass/shared/components';
import CasLink2 from 'src/compass/shared/components/CasLink/CasLink2';
import { IGeneralObjectType } from 'src/compass/site/util';

import { InvalidAddressChip } from '../CustomerContacts/InvalidAddressChip';
import { PreferredChip } from '../CustomerContacts/PreferredChip';
import {
  contactMethods,
  phoneDigits,
  preferredEmail,
  preferredPhoneDigits,
} from '../CustomerContacts/contactPhones';
import { RenderContactsPhone } from './RenderContactsPhone';

interface IProps {
  contact: IGeneralObjectType;
}

/*
  A contact's emails and phone numbers, one per line, with the Preferred marker beside the one
  messages default to. Shared by the Customers dialog's Contacts tab (its Email/Phone column) and
  the Contact dialog the Customers page search box opens.

  The emails, main then additional, come before the numbers - the order an SCE Reports single send
  messages a contact with no Preferred Channel in (see contactMethods) - each with its own
  formatting: the mailto: link and the tel:/sms: icons. The main email's Primary sits outside its
  link, as a number's Mobile / Phone sits beside it (RenderContactsPhone).
*/
export default function RenderContactMethods({ contact }: IProps) {
  const preferredDigits = preferredPhoneDigits(contact);
  const preferredAddress = preferredEmail(contact);

  return (
    <div>
      {contactMethods(contact).map((method) =>
        method.kind === 'email' ? (
          <CasStackRow key={method.value} alignItems="center">
            <span>
              <CasLink2 href={`mailto:${method.value}`}>{method.value}</CasLink2>{' '}
              {method.suffix && <i>{method.suffix}</i>}
            </span>
            {method.value === preferredAddress && <PreferredChip />}
            {method.invalid && <InvalidAddressChip kind="email" />}
          </CasStackRow>
        ) : (
          <RenderContactsPhone
            key={method.suffix}
            value={method.value}
            suffix={method.suffix}
            preferred={!!preferredDigits && phoneDigits(method.value) === preferredDigits}
            invalid={method.invalid}
          />
        )
      )}
    </div>
  );
}
